import React from 'react';
import { createPortal } from 'react-dom';
import qs from 'query-string';
import { useDispatch } from 'react-redux';
import { PropTypes } from 'prop-types';
import RenewJobModal from '../../molecules/renewJobModal';
import ForceJobVisibilityModal from '../../molecules/forceJobVisibilityModal';
import { toggleJobActionDialog } from '../../../hooks/useJobActions/actions';
import { ShareJobModal } from '../../molecules/shareJobModal';
import { CloseJobModal } from '../../molecules/closeJobModal';
import { DeleteJobModal } from '../../molecules/deleteJobModal';
import FeatureJobModal from '../../molecules/featureJobModal';
import JobRulesModal from './jobRulesModal';
import DownloadApplicants from './downloadApplicants';
import { LaunchApplicationBoostAgentModal } from './components/LaunchApplicationBoostAgentModal';

export const JobTableModals = ({
  dialogStates,
  selectedJob,
  jobActions,
  jobActionsLoading,
  jobActionsErrors,
  isNetworkAdmin,
  activeNetwork,
  location,
  showJobRules,
  setShowJobRules,
  findem,
}) => {
  const dispatch = useDispatch();

  return (
    <>
      {createPortal(
        <RenewJobModal
          isOpen={dialogStates.extendJob}
          title={selectedJob?.title}
          company={selectedJob?.organization}
          onClose={() => dispatch(toggleJobActionDialog({ dialog: 'extendJob', isOpen: false }))}
          onSubmit={(e) => {
            jobActions.onExtendJob({ job: selectedJob, extension: e });
          }}
          isSubmitting={jobActionsLoading.isExtending}
          error={jobActionsErrors.extendJob}
        />,
        document.getElementById('portals'),
      )}
      {isNetworkAdmin &&
        createPortal(
          <ForceJobVisibilityModal
            isOpen={dialogStates.forceJobVisibility}
            title={`Set ${selectedJob?.title} job visibility `}
            visibilityValue={selectedJob?.visibility}
            company={selectedJob?.organization}
            onClose={() => dispatch(toggleJobActionDialog({ dialog: 'forceJobVisibility', isOpen: false }))}
            onSubmit={(v) => {
              jobActions.onForceJobVisibility({
                job: selectedJob,
                forcedVisibility: v,
                visibilityFilter: qs.parse(location.search).visibility,
              });
            }}
            isSubmitting={jobActionsLoading.isForcingVisibility}
            error={jobActionsErrors.forceJobVisibility}
          />,
          document.getElementById('portals'),
        )}
      {isNetworkAdmin &&
        createPortal(
          <FeatureJobModal
            isOpen={dialogStates.featureJob}
            title="Update job feature status"
            featureJobValue={selectedJob?.featured}
            onClose={() => dispatch(toggleJobActionDialog({ dialog: 'featureJob', isOpen: false }))}
            onSubmit={(v) => {
              jobActions.onFeatureJob({
                job: selectedJob,
                featured: v,
                featuredFilter: qs.parse(location.search).featured,
              });
            }}
            isSubmitting={jobActionsLoading.isFeaturingJob}
            error={jobActionsErrors.featureJob}
          />,
          document.getElementById('portals'),
        )}
      {createPortal(
        <ShareJobModal
          job={selectedJob}
          isOpen={dialogStates.shareJob}
          onCancel={() => {
            dispatch(toggleJobActionDialog({ dialog: 'shareJob', isOpen: false }));
          }}
        />,
        document.getElementById('portals'),
      )}
      {createPortal(
        <CloseJobModal
          job={selectedJob}
          isOpen={dialogStates.closeJob}
          onCancel={() => {
            dispatch(toggleJobActionDialog({ dialog: 'closeJob', isOpen: false }));
          }}
          isSubmitting={jobActionsLoading.isClosing}
          error={jobActionsErrors.closeJob}
          onSubmit={() => {
            jobActions.onCloseJob({
              jobId: selectedJob.id,
              networkId: activeNetwork.id,
              isNetworkManager: activeNetwork.isManager,
              companyId: selectedJob.organization.id,
            });
          }}
        />,
        document.getElementById('portals'),
      )}
      {createPortal(
        <DeleteJobModal
          isDeleting={jobActionsLoading.isDeleting}
          isClosing={jobActionsLoading.isClosing}
          isOpen={dialogStates.deleteJob}
          onCancel={() => {
            dispatch(toggleJobActionDialog({ dialog: 'deleteJob', isOpen: false }));
          }}
          onCloseJob={() => {
            if (!selectedJob) return;

            jobActions.onDeleteJob({
              jobId: selectedJob.id,
              networkId: activeNetwork.id,
              isNetworkManager: activeNetwork.isManager,
              companyId: selectedJob.organization.id,
            });
          }}
          onDeleteJob={() => {
            if (!selectedJob) return;
            jobActions.onDeleteJob({ job: selectedJob });
          }}
        />,
        document.getElementById('portals'),
      )}
      {createPortal(
        <DownloadApplicants isOpen={dialogStates.jobApplicationDownload} />,
        document.getElementById('portals'),
      )}
      {showJobRules &&
        createPortal(<JobRulesModal onCancel={() => setShowJobRules(false)} />, document.getElementById('portals'))}

      {findem.job &&
        findem.widgetView &&
        createPortal(
          <LaunchApplicationBoostAgentModal
            onClose={() => findem.closeWidget()}
            job={findem.job}
            widgetView={findem.widgetView}
            openWidget={findem.openWidget}
            isOpenWidgetLoading={findem.isLoading}
            setWidgetView={findem.setWidgetView}
            findemError={findem.findemError}
          />,
          document.getElementById('portals'),
        )}
    </>
  );
};

JobTableModals.propTypes = {
  dialogStates: PropTypes.object.isRequired,
  selectedJob: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
  jobActions: PropTypes.object.isRequired,
  jobActionsLoading: PropTypes.object.isRequired,
  jobActionsErrors: PropTypes.object.isRequired,
  isNetworkAdmin: PropTypes.bool.isRequired,
  activeNetwork: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  showJobRules: PropTypes.bool.isRequired,
  setShowJobRules: PropTypes.func.isRequired,
  findem: PropTypes.object.isRequired,
};

JobTableModals.defaultProps = {
  selectedJob: null,
};
